/**
 * usePlaybackSuggestions
 */

import { useMemo } from 'react';

import {
    useUserData,
    useUserLocation,
    useUserSuggestions,
} from './';
import { useMediaConfig } from '../config';

const usePlaybackSuggestions = (experience, options = {}) => {

    const {
        skip = false,
        formatData = false,
    } = options;
    const { runTimeConfig = 'prod' } = useMediaConfig();
    const {
        data: userData, loading: loadingUserData, error: errorUserData,
    } = useUserData();
    const { userId, accessToken } = userData;
    const {
        data: { __typename, ...userLocation }, loading: loadingUserLocation, error: errorUserLocation,
    } = useUserLocation({
        runTimeConfig,
        token: accessToken,
    }, {
        skip: skip || loadingUserData,
    });
    const {
        data: userSuggestions, loading: loadingUserSuggestions, error: errorUserSuggestions,
    } = useUserSuggestions({
        userId,
        userLocation,
    },{
        skip: skip || loadingUserData || loadingUserLocation,
        experience,
    });

    const data = useMemo(() => {

        if (formatData) {

            return {
                topicPlayList: {
                    hasMore: false,
                    mediaPlayback: userSuggestions,
                },
            };

        };

        return userSuggestions;

    }, [
        userSuggestions,
        formatData,
    ]);

    return {
        loading: skip || loadingUserData || loadingUserLocation || loadingUserSuggestions,
        data,
        error: errorUserData || errorUserLocation || errorUserSuggestions,
    };

};

export default usePlaybackSuggestions;
